import { render } from "./ProjectPublicationsSteps.vue?vue&type=template&id=faa0bcc4"
import script from "./ProjectPublicationsSteps.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsSteps.vue?vue&type=script&lang=js"

import "./ProjectPublicationsSteps.vue?vue&type=style&index=0&id=faa0bcc4&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__